import AuthService from 'services/AuthService'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (window.innerWidth <= 600) {
                next({ name: 'index.home' })
            }

            return next()
        })
    },
}
